// extracted by mini-css-extract-plugin
export default {"KeyboardNavigator":"KeyboardNavigator__FQ_AKWMOreOu"};